import React, { Fragment } from 'react';
import styled from 'styled-components';
import { ClickableElement } from '@cko/primitives';
const Summary = styled(ClickableElement) `
  margin: var(--layout-sandgrain);
  padding: var(--layout-soybean) var(--layout-stamp);
  background: var(--action-bg-decorative-hover);
  color: var(--legacy-action-text-default);

  width: 100%;
  text-align: left;
  border-radius: var(--border-r-sandgrain);
  cursor: pointer;
`;
export const SearchSummary = ({ query, onClick }) => {
    function buildSummary() {
        return query
            .split(/([^\s]+)(\w*)\s*(.*?)\s*(?=[^\s:]+\w|$)/gi)
            .filter(Boolean)
            .map((partial, idx) => (React.createElement(Fragment, { key: `${partial + idx}` },
            idx !== 0 && ' ',
            React.createElement("b", null, partial))));
    }
    return (React.createElement(Summary, { onClick: onClick },
        'See all results for ',
        buildSummary()));
};
